import { BDCPMasterDetailModule } from 'brother-dealerapp-component-products-lib';
import { BDSharedModule } from '@brother-apps/brother-dealerapp-shared-lib';
import { CommonModule } from '@angular/common';
import { ContactBoxComponent } from './components/contact-box/contact-box.component';
import { DashboardComponent } from './pages/dashboard/dashboard.page';
import { FormsModule } from '@angular/forms';
import { MasterDetailRootComponent } from './pages/root/master-detail-root.page';
import { MasterDetailRootRoutingModule } from './master-detail-root-routing.module';
import { NewsBoxComponent } from './components/news-box/news-box.component';
import { NewsModule } from '../news/news.module';
import { NgModule } from '@angular/core';
import { ProductsBoxComponent } from './components/products-box/products-box.component';
import { ProjectsModule } from '../projects/projects.module';
import { SharedModule } from '../../shared/shared.module';
import { SalesConciergeBoxComponent } from './components/sales-concierge-box/sales-concierge-box.component';
import { ContactBoxSalesConciergeComponent } from './components/contact-box-sales-concierge/contact-box-concierge.component';
import {BDCSSalesConciergeModule} from 'brother-dealerapp-component-salesconcierge-lib';
import {ITrackingService} from './services/tracking.service.interface';
import {TrackingService} from './services/tracking.service.implementation';
import {CoreModule} from '../../core/core.module';
import {AnnouncementsService} from './services/announcements.service';
import {IAnnouncementsHttpService} from './services/announcements-http.service.interface';
import {AnnouncementModalComponent} from './components/announcement-modal/announcement.modal.component';
import {AnnouncementsHttpService} from './services/announcements-http.service.implementation';
import {ServiceModule} from '../service/service.module';
import { TestPageComponent } from './pages/test-page/test-page.component';
import {ContactWidgetModule} from '../contact-widget/contact-widget.module';
import {CustomBoxComponent} from './components/box-custom/custom-box.component';
import {MainHeaderComponent} from './components/main-header/main-header.component';


@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        FormsModule,
        SharedModule,
        BDSharedModule,
        MasterDetailRootRoutingModule,
        BDCPMasterDetailModule,
        BDCSSalesConciergeModule,
        NewsModule,
        ProjectsModule.forRoot(),
        ServiceModule,
        ContactWidgetModule,
    ],
    declarations: [
        // Pages
        MasterDetailRootComponent,
        DashboardComponent,
        ProductsBoxComponent,
        NewsBoxComponent,
        ContactBoxComponent,
        SalesConciergeBoxComponent,
        ContactBoxSalesConciergeComponent,
        AnnouncementModalComponent,
        TestPageComponent,
        CustomBoxComponent,
        MainHeaderComponent,
    ],
    exports: [
        MainHeaderComponent
    ],
    providers: [
        AnnouncementsService,
        {provide: IAnnouncementsHttpService, useClass: AnnouncementsHttpService },
        {provide: ITrackingService, useClass: TrackingService},
    ],

})
export class MasterDetailRootModule { }
